module.exports = __webpack_public_path__ + "img/dnd_4_splash.6f2c439a.jpg";